<template>
  <el-row style="min-height: 700px;">
    <el-row style="padding-top: 15px;">
      <el-row>
        <el-col :span="MailSet.CheckType == 1 ? 7 : 24" style="border-right: 1px solid #ccc;height: 100%;overflow-y: auto;">
          <el-row>
            <el-select ref="ls" style="width:90%;margin-bottom: 20px;" size="medium" filterable remote reserve-keyword v-model="leftSeach" :loading="loading" @change="checkSeach" :remote-method="remoteMethod" placeholder="请输入部门，人员名称">
              <el-option v-for="item in SeachDate" :key="item.id" :label="item.label" :value="item">
                <span style="float: left">{{ item.label }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{ item.pid == 0 ? '部门' :'人员' }}</span>
              </el-option>
            </el-select>
          </el-row>
          <el-row>
            <el-tree :data="TreeData" lazy :load="loadNode" :props="defaultProps" @node-click="handleNodeClick">
              <span class="custom-tree-node" slot-scope="{ node,data }">
                <label>
                  <span>
                    <img v-if="data.type == '0'" src="@/assets/images/icon_file_fill.png" style="margin-right: 5px;vertical-align: middle;width:15px;position: relative;bottom: 2px;" />
                    <img v-else src="@/assets/images/icon_people_fill.png" style="margin-right: 5px;vertical-align: middle;width:15px;position: relative;bottom: 2px;" />
                  </span>{{ node.label }}
                </label>
              </span>
            </el-tree>
          </el-row>
        </el-col>
        <el-col :span="17" v-if="MailSet.CheckType == 1">
          <el-row>
            <el-table :data="MailSet.CheckList" style="width: 100%;    padding: 0 15px;">
              <el-table-column prop="name" label="名称">
              </el-table-column>
              <el-table-column prop="name" label="类型">
                <template slot-scope="scope">
                  {{scope.row.type ? '部门' : '人员'}}
                </template>
              </el-table-column>
              <el-table-column prop="Position" label="操作" width="100">
                <template slot-scope="scope">
                  <i class="el-icon-close" @click="DelList(scope.$index)"></i>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
        </el-col>
      </el-row>
    </el-row>
    <el-row class="btn">
      <el-button type="primary" @click="SyncUser()">同步通讯录</el-button>
      <el-button @click="Out()">取消</el-button>
      <el-button type="success" v-if="MailSet.CheckType == 1" @click="Save()">确定</el-button>
    </el-row>
  </el-row>

</template>
<script>
  export default {
    data () {
      return {
        TreeData: [],
        SeachDate: [],
        activeName: '0',
        defaultProps: {
          children: 'children',
          label: 'label',
          isLeaf: 'leaf'
        },
        loading: false,
        leftSeach: "",
      }
    },
    props: {
      MailSet: {
        type: Object, default () {
          return {
            type: 0,//类型0默认全部 1 部门 2 人员
            CheckType: 1,//选择类型 0单选 1多选
            CheckList: [],//已选人员
          }
        }
      }
    },
    mounted () {
      this.InitData();
    },
    methods: {
      DelList (i) {
        this.MailSet.CheckList.splice(i, 1);
      },
      InitData () {
        const _this = this;
        _this.Ajax.Get("api/User/GetDetpUser/" + this.MailSet.type).then(res => {
          var dept = res.data.depts;
          var user = res.data.user;
          _this.TreeData = [];
          dept.forEach(item => {
            _this.TreeData.push({
              id: item.oid,
              label: item.name,
              type: 0,
              isLeaf: item.Order == 1
            })
          });
          user.forEach(item => {
            _this.TreeData.push({
              id: item.userId,
              label: item.name,
              type: 1,
              isLeaf: false
            })
          });
        })
      },
      SyncUser () {
        this.$tool.System.load.show("同步中");
        this.Ajax.Get("api/Login/SyncUser").then(res => {
          setTimeout(() => {
            this.$tool.System.load.hide();
            this.InitData();
            this.$tool.System.msg("同步成功！", "提示", 0);
          }, 2000);

        })
      },
      loadNode (node, resolve) {
        const _this = this;
        if (!node.data.id) {
          return;
        }
        _this.Ajax.Get("api/User/GetDetpUser/" + this.MailSet.type, { deptId: node.data.id }).then(res => {
          var dept = res.data.depts;
          var user = res.data.user;
          var dt = [];
          dept.forEach(item => {
            dt.push({
              id: item.oid,
              label: item.name,
              type: 0,
              leaf: item.order == 0
            })
          });
          user.forEach(item => {
            dt.push({
              id: item.userId,
              label: item.name,
              type: 1,
              leaf: true
            })
          });
          resolve(dt);
        });
      },
      handleNodeClick (row) {
        var type = row.type == 0;
        if (type && this.MailSet.type == 2) {
          return;
        }
        var dt = { id: row.id, name: row.label, type: type };
        this.CheckItem(dt);
      },
      remoteMethod (query) {
        const _this = this;
        if (query) {
          _this.loading = true;
          _this.Ajax.Get("api/User/GetSeacTree/" + query).then(res => {
            _this.SeachDate = [];
            res.data.forEach(item => {
              item.children.forEach(it => {
                _this.SeachDate.push(it);
              });
            });
            _this.loading = false;
          });
        } else {
          _this.SeachDate = [];
        }
      },
      checkSeach (node) {
        var type = node.pid == 0;
        if (type && this.MailSet.type == 2) {
          return;
        }
        var dt = { id: node.id, name: node.label, type: type };
        this.CheckItem(dt);
        this.leftSeach = "";
      },
      CheckItem (item) {
        if (this.MailSet.CheckType == 0) {
          this.$emit('SaveMail', item);
        } else {
          for (let i = 0; i < this.MailSet.CheckList.length; i++) {
            const it = this.MailSet.CheckList[i];
            if (it.id == item.id && it.name == item.name && it.type == item.type) {
              this.MailSet.CheckList.splice(i, 1);
              return;
            }
          }
          this.MailSet.CheckList.push(item);
        }
      },
      Out () {
        this.$emit("Hide");
      },
      Save () {
        this.Out();
        this.$emit("SaveMail", this.MailSet.CheckList);
      }
    }
  }
</script>
<style scoped>
  .magin {
    margin-top: 25px;
  }
  .page {
    text-align: right;
  }
  .tag {
    margin-right: 5px;
    margin-bottom: 5px;
  }
  .btn {
    text-align: right;
    position: absolute;
    bottom: 0;
    width: 100%;
  }
</style>